export const EXCMAGREEMENT_DELETE_RESET = 'EXCMAGREEMENT_DELETE_RESET'
export const EXCMAGREEMENT_DELETE_SET_ERROR = 'EXCMAGREEMENT_DELETE_SET_ERROR'
export const EXCMAGREEMENT_DELETE_SET_DELETED = 'EXCMAGREEMENT_DELETE_SET_DELETED'
export const EXCMAGREEMENT_DELETE_TOGGLE_LOADING = 'EXCMAGREEMENT_DELETE_TOGGLE_LOADING'
